export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'TZS 0';
  
  const absAmount = Math.abs(Math.round(amount)); // Round to whole number
  
  // If amount is in millions (1,000,000 or more)
  if (absAmount >= 1000000) {
    const millions = Math.round(amount) / 1000000;
    return `TZS ${millions.toFixed(2)}M`;
  }
  
  // Otherwise, format with commas (no decimals)
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Math.round(amount));
  
  return `TZS ${formatted}`;
};

export const formatCurrencyCompact = (amount) => {
  if (amount === null || amount === undefined) return 'TZS 0';
  
  const absAmount = Math.abs(Math.round(amount));
  
  // If amount is in millions
  if (absAmount >= 1000000) {
    const millions = Math.round(amount) / 1000000;
    return `TZS ${millions.toFixed(1)}M`;
  }
  
  // If amount is in thousands
  if (absAmount >= 1000) {
    const thousands = Math.round(amount) / 1000;
    return `TZS ${thousands.toFixed(0)}K`;
  }
  
  return `TZS ${Math.round(amount)}`;
};